const API_URL = `${process.env.REACT_APP_API_URL}`;
export const GetUserInfo = async (accessToken: string, email: string) => {

  try {
    const response = await fetch(
      `${API_URL}/api/UserInfo/GetUserInfo?userMail=${email}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch Tenants.");
    }

    const data = await response.json();
    if (!data.data) {
      return null;
    }
    // Extract user data from response
    const userData = Array.isArray(data.data) ? data.data[0] : data.data;

    return mapToUserModel(userData);
  } catch (error) {
    throw error;
  }
};

export interface UserModel {
  userID: number;
  tenantID: number;
  userName: string;
  firstName: string;
  lastName: string;
  office365MailId: string;
  isActive: boolean;
  roleID: number;
  userLicenseID: number;
  tenantLicenseID: number;
  licenseType: number;
  noOfUsers: number;
}

export const mapToUserModel = (data: any): UserModel => {
  return {
    userID: data.userID,
    tenantID: data.tenantID,
    userName: data.userName,
    firstName: data.firstName,
    lastName: data.lastName,
    office365MailId: data.office365MailId,
    isActive: data.isActive,
    roleID: data.roleID,
    userLicenseID: data.userLicenseID,
    tenantLicenseID: data.tenantLicenseID,
    licenseType: data.licenseType,
    noOfUsers: data.noOfUsers,
  };
};
